import { createSelector } from 'reselect'
import {
  BUSINESS_VERTICAL_ENERGY,
  BUSINESS_VERTICAL_INSURANCE,
  BUSINESS_VERTICAL_TELECOM,
} from '../SubscriptionFormPageNew/SubscriptionForm/Common/constants'

export const selectAuth = state => state.auth

export const selectAuthData = createSelector(
  selectAuth,
  auth => JSON.parse(localStorage?.getItem('hop-telecom-auth')) || auth.data,
)

// Live-from-Redux selectors for fields that are pushed at runtime by the
// `team.offers-in-cut-period.{teamId}` Echo broadcast. `selectAuthData` falls
// back to localStorage when present, which is fine for the rest of the auth
// data (set once at login) but stale for cutOffers — the broadcast updates
// the slice but not localStorage, so reading via selectAuthData would never
// reflect the live list. These selectors bypass localStorage entirely.
export const selectCutOffers = createSelector(selectAuth, auth => auth.data?.cutOffers ?? [])
export const selectCutOffersUpdatedAt = createSelector(
  selectAuth,
  auth => auth.data?.cutOffersUpdatedAt ?? 0,
)
export const selectTeamName = createSelector(selectAuth, auth => auth.data?.teamName ?? '')
export const selectTeamId = createSelector(selectAuth, auth => auth.data?.teamId ?? null)
export const selectTeamCanCreateLeadsOnOwnVertical = createSelector(
  selectAuth,
  auth => auth.data?.teamCanCreateLeadsOnOwnVertical ?? false,
)
export const selectHopTimusEnabled = createSelector(selectAuth, auth => auth.data?.hopTimusEnabled ?? false)

export const selectAuthError = createSelector(selectAuth, auth => auth.error)

export const selectAuthIsLoading = createSelector(selectAuth, auth => auth.isLoading)

export const selectAuthCommonData = createSelector(selectAuthData, auth => auth.commonData)

export const selectEnergyAuthCommonData = createSelector(selectAuthData, auth => auth.commonData.energy)

export const selectTelecomAuthCommonData = createSelector(selectAuthData, auth => auth.commonData.telecom)

export const selectInsuranceAuthCommonData = createSelector(selectAuthData, auth => auth.commonData.insurance)

export const selectExtraRoutesAuthData = createSelector(selectAuthData, auth => auth.extraRoutes ?? {})

export const selectAuthorizedBusinessVertical = createSelector(selectAuthData, auth => {
  const authorizedSites = auth.authorizedSites ?? {}
  const authorizedBusinessVertical = []
  if (Object.keys(authorizedSites).length > 0) {
    Object.keys(authorizedSites).forEach(key => {
      const site = authorizedSites[key]
      authorizedBusinessVertical.push(site.business_type)
    })
  }
  return authorizedBusinessVertical
})

export const isAllowedEnergyBusinessVertical = createSelector(
  selectAuthorizedBusinessVertical,
  authorizedBusinessVertical => {
    return authorizedBusinessVertical.includes(BUSINESS_VERTICAL_ENERGY)
  },
)

export const isAllowedTelecomBusinessVertical = createSelector(
  selectAuthorizedBusinessVertical,
  authorizedBusinessVertical => {
    return authorizedBusinessVertical.includes(BUSINESS_VERTICAL_TELECOM)
  },
)

export const isAllowedInsuranceBusinessVertical = createSelector(
  selectAuthorizedBusinessVertical,
  authorizedBusinessVertical => {
    return authorizedBusinessVertical.includes(BUSINESS_VERTICAL_INSURANCE)
  },
)
